import { RouterInputs, ReactQueryOptions, api, RouterOutputs } from '@api'
import { staleTimeIndex } from '@specs/constants'
import { TRPCClientErrorLike } from '@trpc/client'
import { UseTRPCInfiniteQueryOptions } from '@trpc/react-query/shared'

type inputType = RouterInputs['SocialManager']['getList']
type queryOptionsType = ReactQueryOptions['SocialManager']['getList']

export const useGetProfiles = (input: inputType, options?: queryOptionsType) => {
    return api.SocialManager.getList.useQuery(input, {
        ...options,
        queryKey: ['SocialManager.getList', input],
        staleTime: 1000 * staleTimeIndex * 60 * 60, // 1 hour
    })
}

type outputType = RouterOutputs['SocialManager']['getList']
type optionsType = UseTRPCInfiniteQueryOptions<'SocialManager.getList', inputType, outputType, TRPCClientErrorLike<any>>

export const useGetProfilesInfinityList = (input: inputType, options?: optionsType) => {
    return api.SocialManager.getList.useInfiniteQuery(input, {
        ...options,
        queryKey: ['SocialManager.getList', input],
        staleTime: 1 * 60 * 60 * 1000 * staleTimeIndex, // 1 hour
        getNextPageParam: (firstPage) => firstPage.nextCursor,
        initialCursor: undefined,
    })
}
